// src/components/arbMonitor/arbMonitorColumns.js

export const getArbMonitorColumns = () => [
  {
    header: "Target        ",
    accessorKey: "Target",
    size: 100,
    enablePinning: true,
    Pin: true,
    sortingFn: (rowA, rowB) => {
      const a = rowA.getValue("Target") || "";
      const b = rowB.getValue("Target") || "";

      // Check if first character is a number
      const aIsNumber = /^\d/.test(a);
      const bIsNumber = /^\d/.test(b);

      // If one starts with number and other doesn't, number should come first
      if (aIsNumber && !bIsNumber) return -1;
      if (!aIsNumber && bIsNumber) return 1;

      // If both are numbers or both are not numbers, sort alphabetically
      return a.localeCompare(b);
    },
    muiTableBodyCellProps: {
      sx: { backgroundColor: "#fff" },
    },
  },
  {
    header: "Acquiror",
    accessorKey: "Acquiror",
    size: 100,
    enablePinning: true,
    Pin: true,
    muiTableBodyCellProps: {
      sx: { backgroundColor: "#fff" },
    },
  },
  {
    header: "Deal Terms",
    muiTableHeadCellProps: {
      sx: {
        align: "center",
        backgroundColor: "rgb(255, 227, 148)",
        borderLeft: "2px solid #666",
        borderBottom: "2px solid #666",
        ".MuiTableSortLabel-icon": {
          display: "none",
        },
        fontSize: "0.75rem",
      },
    },
    columns: [
      {
        header: "Cash",
        accessorKey: "Cash",
        size: 80,
        muiTableHeadCellProps: {
          align: "right",
          sx: {
            verticalAlign: "bottom",
            borderLeft: "2px solid #666",
            ".MuiTableSortLabel-icon": {
              display: "none",
            },
            fontSize: "0.75rem",
          },
        },
        muiTableBodyCellProps: {
          align: "right",
          sx: { borderLeft: "2px solid #666" },
        },
        Cell: ({ cell }) => {
          const value = cell.getValue();
          if (value === 0) return "-";
          if (!value) return "-";
          return new Intl.NumberFormat("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 4,
          }).format(value);
        },
      },
      {
        header: "Stock Ratio         ",
        accessorKey: "Stock_Ratio",
        size: 80,
        muiTableHeadCellProps: {
          align: "right",
          sx: {
            ".MuiTableSortLabel-icon": {
              display: "none",
            },
            fontSize: "0.75rem",
          },
        },
        muiTableBodyCellProps: { align: "right" },
        Cell: ({ cell }) => {
          const value = cell.getValue();
          if (!value) return "-";
          return new Intl.NumberFormat("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 4,
          }).format(value);
        },
      },
      {
        header: "Closing Date         ",
        accessorKey: "Closing_Date",
        size: 100,
        muiTableHeadCellProps: {
          align: "right",
          sx: {
            verticalAlign: "bottom",
            ".MuiTableSortLabel-icon": {
              display: "none",
            },
            fontSize: "0.75rem",
          },
        },
        muiTableBodyCellProps: {
          align: "right",
          sx: { verticalAlign: "bottom" }, // Adjust as needed (top, middle, bottom)
        },
      },
      {
        header: "Deal Value                     ",
        accessorKey: "Deal_Value",
        size: 80,
        muiTableHeadCellProps: { align: "right" },
        muiTableBodyCellProps: { align: "right" },
        Cell: ({ cell }) => {
          const value = cell.getValue();
          if (value === 0) return "-";
          if (!value) return "-";
          return new Intl.NumberFormat("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }).format(value);
        },
      },
    ],
  },
  {
    header: "Price Information",
    muiTableHeadCellProps: {
      sx: {
        align: "center",
        backgroundColor: "rgb(148, 221, 255)",
        borderLeft: "2px solid #666",
        borderBottom: "2px solid #666",
        fontSize: "0.75rem",
      },
    },

    columns: [
      {
        header: "Target Last Px        ",
        accessorKey: "Tgt_Last_Px",
        size: 95,
        muiTableHeadCellProps: {
          align: "right",
          sx: {
            borderLeft: "2px solid #666",
            ".MuiTableSortLabel-icon": {
              display: "none",
            },
            fontSize: "0.75rem",
          },
        },
        muiTableBodyCellProps: {
          align: "right",
          sx: { borderLeft: "2px solid #666" },
        },
        Cell: ({ cell }) => {
          const value = cell.getValue();
          if (value === 0) return "-";
          if (!value) return "-";
          return new Intl.NumberFormat("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }).format(value);
        },
      },
      {
        header: "Acquiror Last Px            ",
        accessorKey: "Acq_Last_Px",
        size: 100,
        muiTableHeadCellProps: { align: "right" },
        muiTableBodyCellProps: { align: "right" },
        Cell: ({ cell }) => {
          const value = cell.getValue();
          if (value === 0) return "-";
          if (!value) return "-";
          return new Intl.NumberFormat("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }).format(value);
        },
      },
    ],
  },

  {
    header: "Gross Spread",
    muiTableHeadCellProps: {
      sx: {
        align: "center",
        backgroundColor: "rgb(235, 205, 255)",
        borderLeft: "2px solid #666",
        borderBottom: "2px solid #666",
        fontSize: "0.75rem",
      },
    },
    columns: [
      {
        header: "Gross Spread          ",
        accessorKey: "Gross_Spread",
        size: 90,
        muiTableHeadCellProps: {
          align: "right",
          sx: {
            borderLeft: "2px solid #666",
            ".MuiTableSortLabel-icon": {
              display: "none",
            },
            fontSize: "0.75rem",
          },
        },
        muiTableBodyCellProps: {
          align: "right",
          sx: { borderLeft: "2px solid #666" },
        },
        Cell: ({ cell }) => {
          const value = cell.getValue();
          const formattedValue = value ? `${Number(value).toFixed(2)}` : "-";
          return (
            <span style={{ color: Number(value) < 0 ? "red" : "black" }}>
              {formattedValue}
            </span>
          );
        },
      },
      {
        header: "Gross Spread %          ",
        accessorKey: "Gross_Spread_Percentage",
        muiTableHeadCellProps: { align: "right" },
        muiTableBodyCellProps: { align: "right" },
        size: 110,
        Cell: ({ cell }) => {
          const value = cell.getValue();
          const formattedValue = value
            ? `${(Number(value) * 100).toFixed(2)}%`
            : "-";
          return (
            <span style={{ color: Number(value) < 0 ? "red" : "black" }}>
              {formattedValue}
            </span>
          );
        },
      },
      {
        header: "Gross RoR            ",
        accessorKey: "Gross_RoR",
        muiTableHeadCellProps: { align: "right" },
        muiTableBodyCellProps: { align: "right" },
        size: 90,
        Cell: ({ cell }) => {
          const value = cell.getValue();
          const formattedValue = value
            ? `${(Number(value) * 100).toFixed(1)}%`
            : "-";
          return (
            <span style={{ color: Number(value) < 0 ? "red" : "black" }}>
              {formattedValue}
            </span>
          );
        },
      },
      {
        header: "Implied Prob                   ",
        accessorKey: "Implied_Probability",
        muiTableHeadCellProps: { align: "right" },
        muiTableBodyCellProps: { align: "right" },
        size: 90,
        Cell: ({ cell }) => {
          const value = cell.getValue();
          // Check if value is a number
          if (!isNaN(value) && value !== null && value !== "") {
            const formattedValue = `${(Number(value) * 100).toFixed(1)}%`;
            return (
              <span style={{ color: Number(value) < 0 ? "red" : "black" }}>
                {formattedValue}
              </span>
            );
          }
          // If it's not a number, return the text value or '-'
          return value || "-";
        },
      },
    ],
  },
  {
    header: "Net Spread",
    muiTableHeadCellProps: {
      sx: {
        align: "center",
        backgroundColor: "rgb(248, 212, 220)",
        borderLeft: "2px solid #666",
        borderBottom: "2px solid #666",
        fontSize: "0.75rem",
      },
    },
    columns: [
      {
        header: "Net Spread                  ",
        accessorKey: "Net_Spread",
        size: 90,
        muiTableHeadCellProps: {
          align: "right",
          sx: { borderLeft: "2px solid #666", fontSize: "0.75rem" },
        },
        muiTableBodyCellProps: {
          align: "right",
          sx: { borderLeft: "2px solid #666" },
        },
        Cell: ({ cell }) => {
          const value = cell.getValue();
          const formattedValue = value ? `${Number(value).toFixed(2)}` : "-";
          return (
            <span style={{ color: Number(value) < 0 ? "red" : "black" }}>
              {formattedValue}
            </span>
          );
        },
      },
      {
        header: "Net Spread %             ",
        accessorKey: "Net_Gross_Spread_Percentage",
        muiTableHeadCellProps: { align: "right", fontSize: "0.75rem" },
        muiTableBodyCellProps: { align: "right" },
        size: 110,
        Cell: ({ cell }) => {
          const value = cell.getValue();
          const formattedValue = value
            ? `${(Number(value) * 100).toFixed(2)}%`
            : "-";
          return (
            <span style={{ color: Number(value) < 0 ? "red" : "black" }}>
              {formattedValue}
            </span>
          );
        },
      },
      {
        header: "Net RoR                 ",
        accessorKey: "Net_RoR",
        muiTableHeadCellProps: { align: "right", fontSize: "0.75rem" },
        muiTableBodyCellProps: { align: "right" },
        size: 90,
        Cell: ({ cell }) => {
          const value = cell.getValue();
          const formattedValue = value
            ? `${(Number(value) * 100).toFixed(1)}%`
            : "-";
          return (
            <span style={{ color: Number(value) < 0 ? "red" : "black" }}>
              {formattedValue}
            </span>
          );
        },
      },
      {
        header: "Implied Prob              ",
        accessorKey: "Net_Implied_Probability",
        muiTableHeadCellProps: { align: "right", fontSize: "0.75rem" },
        muiTableBodyCellProps: { align: "right" },
        size: 90,
        Cell: ({ cell }) => {
          const value = cell.getValue();
          // Check if value is a number
          if (!isNaN(value) && value !== null && value !== "") {
            const formattedValue = `${(Number(value) * 100).toFixed(1)}%`;
            return (
              <span style={{ color: Number(value) < 0 ? "red" : "black" }}>
                {formattedValue}
              </span>
            );
          }
          // If it's not a number, return the text value or '-'
          return value || "-";
        },
      },
    ],
  },
  {
    header: "Downside Information",
    muiTableHeadCellProps: {
      sx: {
        align: "center",
        backgroundColor: "rgb(195, 255, 215)",
        borderLeft: "2px solid #666",
        borderBottom: "2px solid #666",
        fontSize: "0.75rem",
      },
    },
    columns: [
      {
        header: "Target Break Px     ",
        accessorKey: "Tgt_Px_on_Deal_Break",
        size: 105,
        muiTableHeadCellProps: {
          align: "right",
          sx: {
            borderLeft: "2px solid #666",
            ".MuiTableSortLabel-icon": {
              display: "none",
            },
            fontSize: "0.75rem",
          },
        },
        muiTableBodyCellProps: ({ cell, row }) => ({
          align: "right",
          sx: {
            borderLeft: "2px solid #666",
            backgroundColor:
              Number(cell.getValue()) > Number(row.getValue("Tgt_Last_Px"))
                ? "#ffcccb"
                : "transparent",
          },
        }),
        Cell: ({ cell }) => {
          const value = cell.getValue();
          if (value === 0 || !value) return "-";

          return new Intl.NumberFormat("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }).format(value);
        },
      },
      {
        header: "Acquiror Break Px        ",
        accessorKey: "Acq_Px_on_Deal_Break",
        size: 110,
        muiTableHeadCellProps: { align: "right", fontSize: "0.75rem" },
        muiTableBodyCellProps: { align: "right" },
        Cell: ({ cell }) => {
          const value = cell.getValue();
          if (value === 0) return "-";
          if (!value) return "-";
          return new Intl.NumberFormat("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }).format(value);
        },
      },
      {
        header: "Deal Break Spread          ",
        accessorKey: "Spread_on_Deal_Break",
        size: 120,
        muiTableHeadCellProps: { align: "right" },
        muiTableBodyCellProps: { align: "right" },
        Cell: ({ cell }) => {
          const value = cell.getValue();
          if (value === 0) return "-";
          if (!value) return "-";
          return new Intl.NumberFormat("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }).format(value);
        },
      },
    ],
  },
  {
    header: "Net DVD",
    muiTableHeadCellProps: {
      sx: {
        align: "center",
        backgroundColor: "rgb(193, 248, 255)",
        borderLeft: "2px solid #666",
        borderBottom: "2px solid #666",
        fontSize: "0.75rem",
      },
    },
    columns: [
      {
        header: "Net Dividends",
        accessorKey: "Net_Dvds",
        size: 120,
        muiTableHeadCellProps: {
          align: "right",
          sx: {
            borderLeft: "2px solid #666",
            ".MuiTableSortLabel-icon": {
              display: "none",
            },
            fontSize: "0.75rem",
          },
        },
        muiTableBodyCellProps: {
          align: "right",
          sx: { borderLeft: "2px solid #666" },
        },
        Cell: ({ cell }) => {
          const value = cell.getValue();
          if (value === 0) return "-";
          if (!value) return "-";
          return new Intl.NumberFormat("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }).format(value);
        },
      },
    ],
  },
  {
    header: "Target Dividends Information",
    muiTableHeadCellProps: {
      sx: {
        align: "center",
        backgroundColor: "rgb(254, 255, 203)",
        borderLeft: "2px solid #666",
        borderBottom: "2px solid #666",
        fontSize: "0.75rem",
      },
    },
    columns: [
      {
        header: "Tgt Dvds                ",
        accessorKey: "Tgt_DVDs",
        size: 80,
        muiTableHeadCellProps: {
          align: "right",
          sx: {
            borderLeft: "2px solid #666",
            ".MuiTableSortLabel-icon": {
              display: "none",
            },
            fontSize: "0.75rem",
          },
        },
        muiTableBodyCellProps: {
          align: "right",
          sx: { borderLeft: "2px solid #666" },
        },
      },
      {
        header: "Tgt Pass Through %          ",
        accessorKey: "Tgt_Pass_Thru",
        size: 120,
        muiTableHeadCellProps: { align: "right", fontSize: "0.75rem" },
        muiTableBodyCellProps: { align: "right" },
        Cell: ({ cell }) => {
          const value = cell.getValue();
          return value ? `${(Number(value) * 100).toFixed(0)}%` : "-";
        },
      },
      {
        header: "# Tgt Divs             ",
        accessorKey: "Tgt_Num_of_Divs",
        size: 75,
        muiTableHeadCellProps: { align: "right", fontSize: "0.75rem" },
        muiTableBodyCellProps: { align: "right" },
        Cell: ({ cell }) => {
          const value = cell.getValue();
          if (value === 0) return "-";
          if (!value) return "-";
          return new Intl.NumberFormat("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }).format(value);
        },
      },
      {
        header: "Tgt Div Amt              ",
        accessorKey: "Tgt_DVD_Amount",
        size: 90,
        muiTableHeadCellProps: { align: "right", fontSize: "0.75rem" },
        muiTableBodyCellProps: { align: "right" },
        Cell: ({ cell }) => {
          const value = cell.getValue();
          if (value === 0) return "-";
          if (!value) return "-";
          return new Intl.NumberFormat("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }).format(value);
        },
      },
      {
        header: "Total Tgt Div               ",
        accessorKey: "Total_Tgt_DVD",
        size: 90,
        muiTableHeadCellProps: { align: "right", fontSize: "0.75rem" },
        muiTableBodyCellProps: { align: "right" },
        Cell: ({ cell }) => {
          const value = cell.getValue();
          if (value === 0) return "-";
          if (!value) return "-";
          return new Intl.NumberFormat("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }).format(value);
        },
      },
    ],
  },
  {
    header: "Acquiror Dividends Information",
    muiTableHeadCellProps: {
      sx: {
        align: "center",
        backgroundColor: "rgb(255, 222, 253)",
        borderLeft: "2px solid #666",
        borderBottom: "2px solid #666",
        fontSize: "0.75rem",
      },
    },
    columns: [
      {
        header: "Acq Dvds               ",
        accessorKey: "Acq_DVDs",
        size: 80,
        muiTableHeadCellProps: {
          align: "right",
          sx: {
            borderLeft: "2px solid #666",
            ".MuiTableSortLabel-icon": {
              display: "none",
            },
            fontSize: "0.75rem",
          },
        },
        muiTableBodyCellProps: {
          align: "right",
          sx: { borderLeft: "2px solid #666" },
        },
      },
      {
        header: "Acq Pass Thru %         ",
        accessorKey: "Acq_Pass_Thru",
        size: 110,
        muiTableHeadCellProps: { align: "right", fontSize: "0.75rem" },
        muiTableBodyCellProps: { align: "right" },
        Cell: ({ cell }) => {
          const value = cell.getValue();
          return value ? `${(Number(value) * 100).toFixed(0)}%` : "-";
        },
      },
      {
        header: "# of Acq Divs            ",
        accessorKey: "Acq_Num_of_Divs",
        size: 100,
        muiTableHeadCellProps: { align: "right", fontSize: "0.75rem" },
        muiTableBodyCellProps: { align: "right" },
        Cell: ({ cell }) => {
          const value = cell.getValue();
          if (value === 0) return "-";
          if (!value) return "-";
          return new Intl.NumberFormat("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }).format(value);
        },
      },
      {
        header: "Acq Div Amt              ",
        accessorKey: "Acq_DVD_Amount",
        size: 100,
        muiTableHeadCellProps: { align: "right", fontSize: "0.75rem" },
        muiTableBodyCellProps: { align: "right" },
        Cell: ({ cell }) => {
          const value = cell.getValue();
          if (value === 0) return "-";
          if (!value) return "-";
          return new Intl.NumberFormat("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }).format(value);
        },
      },
      {
        header: "Total Acq Div         ",
        accessorKey: "Total_Acq_DVD",
        size: 100,
        muiTableHeadCellProps: { align: "right", fontSize: "0.75rem" },
        muiTableBodyCellProps: { align: "right" },
        Cell: ({ cell }) => {
          const value = cell.getValue();
          if (value === 0) return "-";
          if (!value) return "-";
          return new Intl.NumberFormat("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }).format(value);
        },
      },
    ],
  },
  {
    header: "Volatility Information",
    muiTableHeadCellProps: {
      sx: {
        align: "center",
        backgroundColor: "rgb(200, 255, 230)",
        borderLeft: "2px solid #666",
        borderBottom: "2px solid #666",
        fontSize: "0.75rem",
      },
    },
    columns: [
      {
        header: "Tgt Break Vol             ",
        accessorKey: "Target_Implied_Vol_on_Deal_Break",
        size: 110,
        muiTableHeadCellProps: {
          align: "right",
          sx: {
            borderLeft: "2px solid #666",
            ".MuiTableSortLabel-icon": {
              display: "none",
            },
            fontSize: "0.75rem",
          },
        },
        muiTableBodyCellProps: {
          align: "right",
          sx: { borderLeft: "2px solid #666" },
        },
        Cell: ({ cell }) => {
          const value = cell.getValue();
          return value ? `${(Number(value) * 100).toFixed(0)}%` : "-";
        },
      },
      {
        header: "Tgt Close Vol            ",
        accessorKey: "Target_Implied_Vol_on_Deal_Close",
        size: 110,
        muiTableHeadCellProps: { align: "right", fontSize: "0.75rem" },
        muiTableBodyCellProps: { align: "right" },
        Cell: ({ cell }) => {
          const value = cell.getValue();
          return value ? `${(Number(value) * 100).toFixed(0)}%` : "-";
        },
      },
      {
        header: "Acq Break Vol             ",
        accessorKey: "Acquiror_Implied_Vol_on_Deal_Break",
        size: 110,
        muiTableHeadCellProps: { align: "right", fontSize: "0.75rem" },
        muiTableBodyCellProps: { align: "right" },
        Cell: ({ cell }) => {
          const value = cell.getValue();
          return value ? `${(Number(value) * 100).toFixed(0)}%` : "-";
        },
      },
      {
        header: "Acq Close Vol             ",
        accessorKey: "Acquiror_Implied_Vol_on_Deal_Close",
        size: 110,
        muiTableHeadCellProps: { align: "right", fontSize: "0.75rem" },
        muiTableBodyCellProps: { align: "right" },
        Cell: ({ cell }) => {
          const value = cell.getValue();
          return value ? `${(Number(value) * 100).toFixed(0)}%` : "-";
        },
      },
    ],
  },
];
